export const VAT_COUNTRY_OPTIONS = [
  { code: "IT", name: "Italia" },
  { code: "AL", name: "Albania" },
  { code: "AD", name: "Andorra" },
  { code: "AM", name: "Armenia" },
  { code: "AT", name: "Austria" },
  { code: "AZ", name: "Azerbaigian" },
  { code: "BY", name: "Bielorussia" },
  { code: "BE", name: "Belgio" },
  { code: "BA", name: "Bosnia ed Erzegovina" },
  { code: "BG", name: "Bulgaria" },
  { code: "CY", name: "Cipro" },
  { code: "HR", name: "Croazia" },
  { code: "DK", name: "Danimarca" },
  { code: "EE", name: "Estonia" },
  { code: "FI", name: "Finlandia" },
  { code: "FR", name: "Francia" },
  { code: "GE", name: "Georgia" },
  { code: "DE", name: "Germania" },
  { code: "GI", name: "Gibilterra" },
  { code: "EL", name: "Grecia" },
  { code: "IE", name: "Irlanda" },
  { code: "XI", name: "Irlanda del Nord" },
  { code: "IS", name: "Islanda" },
  { code: "XK", name: "Kosovo" },
  { code: "LV", name: "Lettonia" },
  { code: "LI", name: "Liechtenstein" },
  { code: "LT", name: "Lituania" },
  { code: "LU", name: "Lussemburgo" },
  { code: "MK", name: "Macedonia del Nord" },
  { code: "MT", name: "Malta" },
  { code: "MD", name: "Moldavia" },
  { code: "MC", name: "Monaco" },
  { code: "ME", name: "Montenegro" },
  { code: "NO", name: "Norvegia" },
  { code: "NL", name: "Paesi Bassi" },
  { code: "PL", name: "Polonia" },
  { code: "PT", name: "Portogallo" },
  { code: "GB", name: "Regno Unito" },
  { code: "CZ", name: "Rep. Ceca" },
  { code: "RO", name: "Romania" },
  { code: "RU", name: "Russia" },
  { code: "SM", name: "San Marino" },
  { code: "RS", name: "Serbia" },
  { code: "SK", name: "Slovacchia" },
  { code: "SI", name: "Slovenia" },
  { code: "ES", name: "Spagna" },
  { code: "SE", name: "Svezia" },
  { code: "CH", name: "Svizzera" },
  { code: "TR", name: "Turchia" },
  { code: "UA", name: "Ucraina" },
  { code: "HU", name: "Ungheria" },
  { code: "VA", name: "Città del Vaticano" },
];
